import type { LucideIcon } from 'lucide-react';
import { Building2, CalendarDays, ClipboardCheck, FileSignature, ListChecks, Phone, UserCheck, UserRound } from 'lucide-react';

export interface ProspectPortalStepNavItem {
  name: string;
  href: string;
  icon: LucideIcon;
  step: number;
  stepLabel: string;
}

/** Prospect journey — sidebar order and step numbers. */
export const PROSPECT_PORTAL_STEPS: ProspectPortalStepNavItem[] = [
  {
    step: 1,
    stepLabel: 'Step 1',
    name: 'My Information',
    href: '/my-information',
    icon: UserRound,
  },
  {
    step: 2,
    stepLabel: 'Step 2',
    name: 'Discovery Call',
    href: '/discovery-call',
    icon: Phone,
  },
  {
    step: 3,
    stepLabel: 'Step 3',
    name: 'Shortlist Units',
    href: '/shortlist-units',
    icon: ListChecks,
  },
  {
    step: 4,
    stepLabel: 'Step 4',
    name: 'Book Tours',
    href: '/book-tours',
    icon: CalendarDays,
  },
  {
    step: 5,
    stepLabel: 'Step 5',
    name: 'Analyze Units',
    href: '/analyze-units',
    icon: ClipboardCheck,
  },
  {
    step: 6,
    stepLabel: 'Step 6',
    name: 'Apply to a Unit',
    href: '/apply-to-unit',
    icon: Building2,
  },
  {
    step: 7,
    stepLabel: 'Step 7',
    name: 'Selection',
    href: '/selection',
    icon: UserCheck,
  },
  {
    step: 8,
    stepLabel: 'Step 8',
    name: 'Sign Your Lease',
    href: '/lease-signing',
    icon: FileSignature,
  },
];

export const PROSPECT_PORTAL_PATHS = PROSPECT_PORTAL_STEPS.map((item) => item.href);
